import { format, parseJSON } from "date-fns";
import { Box, ResponsiveContext, Stack, Text } from "grommet";
import React from "react";
import styled from "styled-components";

import { Link, useNavigate } from "react-router-dom";

import SkeletonWrapper from "../components/SkeletonWrapper";
import StyledModal from "../components/StyledModel";
import {} from "grommet";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import LinkButton from "../components/LinkButton";
import { SeasonRow } from "../seasons/SeasonRow";
import ScrollContainer from "./ScrollContainer";

const DateScrollViewGridDiv = styled.div`
    display: grid;
`;

const DateScrollViewGridItem = styled.div`
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    box-sizing: border-box;
    overflow: hidden;
`;

const DateScrollViewGridRowContainer = styled.div`
    padding: 1rem;
    cursor: pointer;
`;

const DateScrollViewGridRow = styled.div`
    display: grid;
    grid-template-columns: repeat(${(props) => props.count}, 1fr);
    gap: 5px;
`;

const DateScrollViewGridItemContainer = styled.div`
    grid-column-start: ${(props) => props.start};
    grid-column-end: ${(props) => props.end};
    min-height: 60px;
    display: flex;
    align-items: center;
`;

interface DateScrollViewProps {
    data: StartEndDateEntity[];
    render: (item: StartEndDateEntity) => React.ReactNode;
}
interface StartEndDateEntity {
    startDate: string;
    endDate: string;
    id: string;
    name: string;
}

const dateFormat = "yyyy-MM-dd";

const DateScrollView = ({ data, render }: DateScrollViewProps) => {
    const [orderedData, setOrderedData] = React.useState(data.sort((a, b) => parseJSON(a.startDate).getTime() - parseJSON(b.startDate).getTime()));
    const size = React.useContext(ResponsiveContext);
    return (
        <DateScrollViewGridDiv>
            <ScrollContainer direction={"-x"} style={{ maxWidth: "100%" }} scrollToLast>
                <DateScrollViewGridRowContainer>
                    <DateScrollViewGridRow count={size == "small" ? orderedData.length : orderedData.length + 1}>
                        {orderedData.map((item, i) => (
                            <DateScrollViewGridItemContainer key={item.id} start={i + 1} end={i + 2} title={item.startDate + " - " + item.endDate}>
                                <DateScrollViewGridItem color="true">
                                    <Box>
                                        {render(item)}
                                        <Box direction="row" justify="evenly" align="center" fill={"horizontal"} gap="small">
                                            <Text size="small">{format(parseJSON(item.startDate), dateFormat)}</Text>
                                            <Text size="small">{format(parseJSON(item.endDate), dateFormat)}</Text>
                                        </Box>
                                    </Box>
                                </DateScrollViewGridItem>
                            </DateScrollViewGridItemContainer>
                        ))}
                        {size != "small" && <Box width={size}></Box>}
                    </DateScrollViewGridRow>
                </DateScrollViewGridRowContainer>
            </ScrollContainer>
        </DateScrollViewGridDiv>
    );
};

// <Box direction="row" pad="small" gap="small" fill>
//     {orderedData.map((date, index) => (
//         <Box height={"small"} background={"background"} fill>
//             {date.startDate}
//         </Box>
//     ))}
// </Box>
export default DateScrollView;
